import { render, staticRenderFns } from "./UserInjuryCards.vue?vue&type=template&id=dc763510&"
import script from "./UserInjuryCards.vue?vue&type=script&lang=js&"
export * from "./UserInjuryCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports